
	$(document).ready(function(){
$('.tutorial-slide').first().addClass('active');
$('.tutorial-slide').hide();    
$('.active').show();

    $('.arrow-right-game').click(function(){

    $('.active').removeClass('active').addClass('oldActive');    
                   if ( $('.oldActive').is(':last-child')) {
        $('.tutorial-slide').first().addClass('active');
        }
        else{
        $('.oldActive').next().addClass('active');
        }
    $('.oldActive').removeClass('oldActive');
    $('.tutorial-slide').hide();
    $('.active').show();
        
        
    });
    
       $('.arrow-left-game').click(function(){
    $('.active').removeClass('active').addClass('oldActive');    
           if ( $('.oldActive').is(':first-child')) {
        $('.tutorial-slide').last().addClass('active');
        }
           else{
    $('.oldActive').prev().addClass('active');
           }
    $('.oldActive').removeClass('oldActive');
    $('.tutorial-slide').hide();
    $('.active').show();
    });
   
});




	$(document).ready(function(){
$('.tutorial-shield').first().addClass('active2 ');
$('.tutorial-shield').hide();    
$('.active2').show();

    $('.arrow-right-shield').click(function(){

    $('.active2').removeClass('active2').addClass('oldActive2');    
                   if ( $('.oldActive2').is(':last-child')) {
        $('.tutorial-shield').first().addClass('active2');
        }
        else{
        $('.oldActive2').next().addClass('active2');
        }
    $('.oldActive2').removeClass('oldActive2');
    $('.tutorial-shield').hide();
    $('.active2').show();
        
        
    });
    
       $('.arrow-left-shield').click(function(){
    $('.active2').removeClass('active2').addClass('oldActive2');    
           if ( $('.oldActive2').is(':first-child')) {
        $('.tutorial-shield').last().addClass('active2');
        }
           else{
    $('.oldActive2').prev().addClass('active2');
           }
    $('.oldActive2').removeClass('oldActive2');
    $('.tutorial-shield').hide();
    $('.active2').show();
    });
   
});
/*quotes*/
	$(document).ready(function(){
$('.quotes').first().addClass('active3');
$('.quotes').hide();    
$('.active3').show();

    $('.quotes-arrow-right').click(function(){

    $('.active3').removeClass('active3').addClass('oldActive3');    
                   if ( $('.oldActive3').is(':last-child')) {
        $('.quotes').first().addClass('active3');
        }
        else{
        $('.oldActive3').next().addClass('active3');
        }
    $('.oldActive3').removeClass('oldActive3');
    $('.quotes').hide();
    $('.active3').show();
        
        
    });
    
       $('.quotes-arrow-left').click(function(){
    $('.active3').removeClass('active3').addClass('oldActive3');    
           if ( $('.oldActive3').is(':first-child')) {
        $('.quotes').last().addClass('active3');
        }
           else{
    $('.oldActive3').prev().addClass('active3');
           }
    $('.oldActive3').removeClass('oldActive3');
    $('.quotes').hide();
    $('.active3').show();
    });
   
});


    
